var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceErr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 75,
    viewBox: "0 0 70 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1775 41.7818C44.724 42.5447 51.5728 46.0266 58.7115 51.3396C58.9978 51.5526 59.2745 51.7756 59.5413 52.0079C52.5739 52.2495 46.9998 57.9738 46.9998 65C46.9998 66.0325 47.1202 67.037 47.3477 68H36.3702H27.9335H3.6315C1.62934 68 0 66.3631 0 64.3516V62.6454C0 58.2063 2.0712 53.9892 5.61984 51.3396C12.7586 46.0127 19.6073 42.5447 21.1538 41.7818C21.3609 41.6847 21.4852 41.4766 21.4852 41.2546V34.9844C20.5325 33.3198 19.9111 31.558 19.6625 29.9627C18.9722 29.9073 18.047 28.9223 17.0528 25.3988C15.6859 20.5852 17.1357 19.8777 18.3508 19.9887C18.1161 19.3229 17.9504 18.657 17.8261 18.005C17.398 15.7577 17.2738 13.663 17.7985 11.6655C18.4198 8.98816 19.8697 6.83798 21.4852 5.17333C22.507 4.07744 23.6669 3.12026 24.8958 2.34343C25.9038 1.64982 27.0084 1.05333 28.2097 0.637163C29.1486 0.318103 30.1566 0.110023 31.2198 0.0545346C34.4923 -0.222906 36.9916 0.595546 38.7728 1.6637C41.4515 3.14801 42.4595 5.10397 42.4595 5.10397C42.4595 5.10397 48.5764 5.53401 46.5052 18.005C46.3948 18.6709 46.2153 19.3229 45.9805 19.9887C47.1956 19.8777 48.6317 20.5852 47.2785 25.3988C46.2843 28.9223 45.373 29.9073 44.6688 29.9627C44.4341 31.5442 43.8127 33.2782 42.8461 34.929V41.2546C42.8461 41.4766 42.9704 41.6847 43.1775 41.7818Z",
    fill: "#F31919"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 10,
    transform: "matrix(-1 0 0 1 60 65)",
    fill: "#F31919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7875 60.5361C65.0708 60.81 65.0708 61.2542 64.7875 61.5281L61.1969 65L64.7875 68.4719C65.0708 68.7458 65.0708 69.19 64.7875 69.4639C64.5042 69.7378 64.0449 69.7378 63.7616 69.4639L60.171 65.992L56.2384 69.7946C55.9551 70.0685 55.4958 70.0685 55.2125 69.7946C54.9292 69.5206 54.9292 69.0765 55.2125 68.8026L59.1451 65L55.2125 61.1974C54.9292 60.9235 54.9292 60.4794 55.2125 60.2054C55.4958 59.9315 55.9551 59.9315 56.2384 60.2054L60.171 64.008L63.7616 60.5361C64.0449 60.2622 64.5042 60.2622 64.7875 60.5361Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceErr);
export default __webpack_public_path__ + "static/media/face_err.6bbc3db572551f84dbe059b63477f81c.svg";
export { ForwardRef as ReactComponent };